import { useEffect, useState } from 'react';

import Base from '../../../utils/base'
import CustomTable from '../../../layout/custom_table/index'

export default function Category() {
  var base = new Base()
  const [arr_header, set_arr_header] = useState([
    {
      label: base.i18n.t('name'),
      data: 'name',
    },
  ])
  const [arr, set_arr] = useState([])

  function on_update_data(arr){
    arr.forEach((data, index) => {
      if(data.file_name != null)
        data.file_name = base.host + '/image/category?file_name=' + data.file_name
    })
    set_arr(arr)
  }

  return (
    <div>
      <h3>{base.i18n.t('category')}</h3>
      <CustomTable
        url='/category'
        arr_header={arr_header}
        arr={arr}
        url_update='/category/action'
        url_create='/category/action'
        url_delete='/category'
        on_update_data={data => on_update_data(data)}/>
    </div>
  );
}
